import * as Yup from "yup";
import dayjs from "dayjs";

export const validationSchema = Yup.object({
    createDate: Yup.lazy((val) => {

        let from = val?.from ? val.from : ""
        let to = val?.to ? val.to : ""

        let valueSchema;

        if (from !== "" || to !== "") {
            valueSchema = Yup
                .string()
                .required('Date is required')
        }

        return Yup.object().shape({
            from: valueSchema,
            to: valueSchema
        })

    }),
    loadDate: Yup.lazy((val) => {

        let from = val?.from ? val.from : ""
        let to = val?.to ? val.to : ""

        let valueSchema;

        if (from !== "" || to !== "") {
            valueSchema = Yup
                .string()
                .required('Date is required')
        }

        return Yup.object().shape({
            from: valueSchema,
            to: valueSchema
        })

    })
})

export const initialValues = {
    createDate: {
        from: "",
        to: ""
    },
    loadDate: {
        from: "",
        to: ""
    },
    // filterCreateDateFrom: "", // dayjs(),
    // filterCreateDateTo: "", // dayjs(),
    repoNumber: "",
    sealNo: "",
}